const CardNumber = (properties) => (
  <div className="w-56 md:w-72 flex justify-center items-end border border-solid border-apple">
    <div className="h-14 md:h-[4.5rem] border border-solid border-y-0 border-l-0 border-apple flex items-center">
      <span className="text-2xl md:text-4xl text-apple font-jomolhari font-normal pr-4">
        {properties.number}
      </span>
    </div>
    <div>
      <h2 className="text-sm md:text-lg text-apple font-normal mb-0.5 py-2 pl-2 md:pl-6">
        <span className="font-jomolhari">
          {properties.title}
          <br />
          <p className="text-xs font-normal font-josefin pt-2">
            {properties.description}
          </p>
        </span>
      </h2>
    </div>
  </div>
);

export default CardNumber;
